<template>
  <button class="select-area" @click="onClick">
    <span class="select-area__icon"></span>
    <div class="select-area__text">
      {{ label }}
    </div>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.select-area {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 1.6rem;
  line-height: 1.6;
  cursor: pointer;
  text-decoration: none;
  color: $link;
  background-color: $gray-3;
  border-radius: 8px;
  width: 100%;

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }

  &__icon {
    background-image: url('../../../../../images/icons/link-plus-circle.svg');
    background-repeat: no-repeat;
    background-color: $gray-3;
    object-fit: contain;
    width: 20px;
    height: 20px;
  }

  &__text {
    padding: 32px 0;
  }
}
</style>
